module.exports = __webpack_public_path__ + "img/resume-builder-hover.919803c5.svg";